const updates = [
  { comic: '斗破苍穹', chapter: '第425话', time: '10分钟前', tag: '刚刚更新', tagColor: 'bg-primary-100 text-primary-600' },
  { comic: '一人之下', chapter: '第638话', time: '25分钟前', tag: '热门', tagColor: 'bg-accent-100 text-accent-700' },
  { comic: '间谍过家家', chapter: '第96话', time: '1小时前', tag: '新话', tagColor: 'bg-primary-100 text-primary-600' },
  { comic: '海贼王', chapter: '第1125话', time: '2小时前', tag: '更新', tagColor: 'bg-secondary-100 text-secondary-700' },
  { comic: '咒术回战', chapter: '第268话', time: '3小时前', tag: '热门', tagColor: 'bg-accent-100 text-accent-700' },
  { comic: '镇魂街', chapter: '第392话', time: '5小时前', tag: '国漫', tagColor: 'bg-primary-100 text-primary-600' },
  { comic: '葬送的芙莉莲', chapter: '第138话', time: '7小时前', tag: '更新', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            最新快讯
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            追踪漫画最新更新动态，第一时间获知连载漫画更新消息
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, i) => (
              <div key={i} className={`relative pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[calc(0.5rem+5px)] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <div>
                      <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.comic} <span className="text-primary-500 font-medium">{item.chapter}</span></h3>
                      <p className="text-sm text-foreground-500">{item.time}</p>
                    </div>
                    <span className={`text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}